<script setup>
import { computed } from 'vue'
import { getI18n } from '@/plugins/i18n'
import { useRoute } from 'vue-router'
import { menuRoutes } from '@/router'

import { useWebSiteStore } from '@/stores/web-site.store'

const i18n = getI18n()
const webSiteStore = useWebSiteStore()
const route = useRoute()

const breadcrumbEntries = computed(() => {
  const crumbs = []
  const menuEntries = webSiteStore.getMenuEntries()
  const currentMenuEntry = menuEntries.find(item => menuRoutes[item.code] === route.path)

  fillBreadcrumb(menuEntries, currentMenuEntry, crumbs)

  return crumbs
})

function fillBreadcrumb(menuEntries, item, crumbs) {
  if (item) {
    const crumb = {
      label: i18n.t(item.code, 2),
      to: menuRoutes[item.code],
    }
    if (item.icon) {
      crumb.icon = item.icon
    }
    crumbs.unshift(crumb)
    if (item.parent_ref) {
      const parentItem = menuEntries.find(i => i.code === item.parent_ref)
      fillBreadcrumb(menuEntries, parentItem, crumbs)
    }
  }
}

</script>
<template>
  <q-breadcrumbs
    gutter="sm"
  >
    <template #separator>
      <q-icon
        size="1rem"
        name="mdi-chevron-right"
        color="primary"
      />
    </template>
    <q-breadcrumbs-el
      v-for="(crumb, index) in breadcrumbEntries"
      :key="index"
      :label="crumb.label"
      :to="crumb.to"
      :icon="crumb.icon"
    />
  </q-breadcrumbs>
</template>
